import { Type } from 'class-transformer';
import { IsNumber } from 'class-validator';
import { MerchantDto } from '../merchant.dto';

export class GiftCardTransferStatsDto {
  @IsNumber()
  public processed: number;

  @IsNumber()
  public notProcessed: number;

  @IsNumber()
  public all: number;

  @Type(() => MerchantDto)
  public merchant?: MerchantDto;
}
